<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Data Industri</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/indagindustri">Data Industri</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Data Industri</h4>
                  <p class="card-title-desc mb-0">Data Industri.</p>
                </div>
                <div>
                  <!-- <button type="button" class="btn btn-success" @click="form.show = true">Tambah Baru</button> -->
                </div>
              </div>

              <hr>

              <data-attribut :data="indagindustri" :show_tambah_btn="true" @tambah="tambah">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th class="text-center">No</th>
                        <th>Nama Perusahaan</th>
                        <th>Nama Pemilik</th>
                        <th>Kontak</th>
                        <th>Alamat</th>
                        <th class="text-center">Aksi</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in indagindustri.data" :key="index">
                        <td scope="row" class="text-center">{{ indagindustri.from + index }}</td>
                        <td scope="row" v-text="row.nama_perusahaan"></td>
                        <td scope="row" v-text="row.nama_pemilik || '-'"></td>
                        <td scope="row" v-text="row.kontak_no || '-'"></td>
                        <td scope="row" v-text="row.alamat_jalan"></td>
                        <td scope="row" class="text-center">
                          <a @click="edit(row)" class="p-0 btn btn-sm btn-link">Edit</a> |
                          <a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a>
                        </td>
                      </tr>
                      <tr v-if="indagindustri.data.length == 0">
                        <td scope="row" colspan="6" class="text-center">
                          <i>Tidak ditemukan data!</i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </data-attribut>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

  <modal :show="form.show" @close="form.show = false" :title="(form.id ? 'Ubah' : 'Tambah') + ' Industri'"
    backdrop="static" size="xl">
    <template #default>
      <form @submit.prevent="action">

        <div class="d-flex">
          <div class="p-3 pt-0 flex-fill">
            <div class="mb-2 row">
              <label for="nama_perusahaan" class="col-sm-2 col-form-label">Nama Perusahaan</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="nama_perusahaan"
                  v-model="form.data.nama_perusahaan">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="nama_pemilik" class="col-sm-2 col-form-label">Nama Pemilik</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="nama_pemilik"
                  v-model="form.data.nama_pemilik">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="alamat" class="col-sm-2 col-form-label">Alamat</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="alamat"
                  v-model="form.data.alamat_jalan">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="badan_usaha" class="col-sm-2 col-form-label">Badan Usaha</label>
              <div class="col-sm-10">
                <select name="jenis_badan_usaha" id="badan_usaha" class="form-select" v-if="!form.readonly" v-model="form.data.jenis_badan_usaha">
                  <option value="">Pilih Badan Usaha</option>
                  <option value="PT">PT</option>
                  <option value="UD">UD</option>
                  <option value="KUB">KUB</option>
                  <option value="CV">CV</option>
                  <option value="PO">PO</option>
                </select>
                <input type="text" v-if="form.readonly" readonly class="form-control-plaintext" id="badan_usaha" v-model="form.data.jenis_badan_usaha">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="jenis_industri" class="col-sm-2 col-form-label">Jenis Industri</label>
              <div class="col-sm-10">
                <select name="jenis_industri_id" id="jenis_industri" class="form-select" v-if="!form.readonly" v-model="form.data.jenis_industri_id">
                  <option value="">Pilih Jenis Industri</option>
                  <option v-for="(r, i) in master.jenis_industri" :key="`jenis-industri-${i}`" :value="r.id" v-text="r.jenis_industri"></option>
                </select>
                <input type="text" v-if="form.readonly" class="form-control-plaintext" id="jenis_industri" v-model="form.data.jenis_industri">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="jenis_produk" class="col-sm-2 col-form-label">Jenis Produk</label>
              <div class="col-sm-10">
                <select name="jenis_produk_id" id="jenis_produk" class="form-select" v-if="!form.readonly" v-model="form.data.jenis_produk_id">
                  <option value="">Pilih Jenis Industri</option>
                  <option v-for="(r, i) in master.jenis_produk" :key="`jenis-industri-${i}`" :value="r.id" v-text="r.jenis_produk"></option>
                </select>
                <input type="text" v-if="form.readonly" class="form-control-plaintext" id="jenis_produk"
                  v-model="form.data.jenis_produk">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="kbli" class="col-sm-2 col-form-label">KBLI</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly" :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="kbli" v-model="form.data.kbli">
              </div>
            </div>
          </div>

          <div>
            <div class="d-grid gap-2 flex-row">
              <button type="button" v-if="form.readonly && form.id" @click="form.readonly = false" class="btn btn-outline-success">Ubah Perusahaan</button>
              <button type="submit" v-if="!form.readonly" class="btn btn-success">Simpan</button>
              <button type="button" v-if="!form.readonly" @click="form.readonly = true" class="btn btn-danger">Batal</button>
            </div>
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import DataAttribut from '@/components/DataAttribut'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import axios from 'axios'

export default {
  layout: Layout,
  components: { Modal, DataAttribut },
  props: {
    indagindustri: Object
  },
  data() {
    return {
      form: {
        show: false,
        id: null,
        readonly: true,
        data: {}
      },
      master: {
        jenis_industri: [],
        jenis_produk: []
      }
    }
  },
  methods: {
    tambah() {
      this.form.show = true;
      this.form.readonly = false;
      this.form.data = {};
      this.form.data.jenis_badan_usaha = '';
      this.form.data.jenis_industri_id = '';
      this.form.data.jenis_produk_id = '';
    },
    edit({ id }) {
      this.form.id = id;
      this.form.show = true;
      this.form.readonly = true;
      axios.get('/admin/indagindustri/' + id)
        .then(res => {
          this.form.data = res.data.industri || {};
          this.master.jenis_industri = res.data.jenis_industri;
          this.master.jenis_produk = res.data.jenis_produk;
        })
    },
    action() {
      if (this.form.id) {
        this.$inertia.put('/admin/indagindustri/' + this.form.id, this.form.data);
      } else {
        this.$inertia.post('/admin/indagindustri', this.form.data);
      }
      this.form.show = false;
      this.form.id = null;
      this.form.data = {};
    },
    remove(row) {
      if(confirm('Konfirmasi Proses Penghapusan?'))
      this.$inertia.delete('/admin/indagindustri/' + row.id);
    }
  },
}
</script>
